import React from 'react';
import images from '../../../assets/images';

import styles from '../../../assets/css/layoutMain/sidebarMenuLeft/sidebarMenuLeft.module.css';
import { NavLink } from 'react-router-dom';

const SidebarMenuLeft = () => {
    return (
        <div className={styles.cardMenu}>
            {/* MENU */}
            <ul className={styles.navList}>
                <li className={styles.navItem}>
                    <NavLink
                        className={({ isActive }) =>
                            isActive
                                ? `${styles.active} ${styles.navLink}`
                                : styles.navLink
                        }
                        to="/home">
                        <img
                            className={styles.icon}
                            src={images.homeIcon}
                            alt=""
                        />
                        Home
                    </NavLink>
                    {/* <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.homeIcon}
                            alt=""
                        />
                        Home
                    </a> */}
                </li>
                <li className={styles.navItem}>
                    <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.recurso4}
                            alt=""
                        />
                        Network
                    </a>
                </li>
                <li className={styles.navItem}>
                    <NavLink
                        className={({ isActive }) =>
                            isActive
                                ? `${styles.active} ${styles.navLink}`
                                : styles.navLink
                        }
                        to="/provider-directory">
                        <img
                            className={styles.icon}
                            src={images.recurso6}
                            alt=""
                        />
                        Providers
                    </NavLink>

                    {/* <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.homeIcon}
                            alt=""
                        />
                        Providers
                    </a> */}
                </li>
                <li className={styles.navItem}>
                    <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.recurso8}
                            alt=""
                        />
                        Groups
                    </a>
                </li>
                <li className={styles.navItem}>
                    <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.recurso10}
                            alt=""
                        />
                        Announcements
                    </a>
                </li>
                <li className={styles.navItem}>
                    <a className={styles.navLink} href="#!">
                        <img
                            className={styles.icon}
                            src={images.recurso12}
                            alt=""
                        />
                        Events
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default SidebarMenuLeft;
